/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G5_DInputs */

const en_mk_sec_pg_g5_d = /** @type {(inputs: Mk_Sec_Pg_G5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A failed run retries at most once, then stops with the reason recorded. No agent spins forever.`)
};

const id_mk_sec_pg_g5_d = /** @type {(inputs: Mk_Sec_Pg_G5_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run yang gagal diulang paling banyak sekali, lalu berhenti dengan alasan yang tercatat. Tidak ada agen yang berputar tanpa akhir.`)
};

/**
* | output |
* | --- |
* | "A failed run retries at most once, then stops with the reason recorded. No agent spins forever." |
*
* @param {Mk_Sec_Pg_G5_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g5_d = /** @type {((inputs?: Mk_Sec_Pg_G5_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G5_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g5_d(inputs)
	return en_mk_sec_pg_g5_d(inputs)
});